import type { IClassroomEvaluation } from 'interfaces/classrooms';
import type { IProfessorAreaEvaluationsList } from 'interfaces/professor_area/evaluations';

/** Mapeia avaliação da turma (admin) para o formato usado na prévia de pesos. */
export function mapClassroomEvaluationForWeightPreview(
  e: IClassroomEvaluation
): IProfessorAreaEvaluationsList {
  return {
    id: e.id,
    classroom_id: e.classroom_id,
    evaluation_id: e.evaluation_id,
    evaluation_kind:
      e.evaluation_kind === 'discursive' ? 'discursive' : 'objetive',
    evaluation_name: e.evaluation_name,
    evaluation_type: e.evaluation_type,
    kind: e.kind,
    max_attempts: e.max_attempts,
    name: e.name,
    parent_id: '',
    passing_score: e.passing_score,
    pending_evaluation_attempts_count: 0,
    replacements: [],
    requirements: e.requirements ?? [],
    rule: (e as { rule?: string }).rule ?? '',
    weight: String(e.weight ?? 0)
  };
}
